///include /assets/js/app/p/brand.js
///include /assets/js/app/p/sbproduct/vps.js
///include /assets/js/app/p/sbproduct/managed_vps.js
///include /assets/js/app/p/sbproduct/vps_backup.js
///include /assets/js/app/p/sbproduct/vps_addon.js
///include /assets/js/app/p/sbproduct/vps_os.js
///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/p/vps.js
///include /assets/js/app/s/catalogue.js
///include /assets/js/app/p/description-template-compiler.js

"use strict"

class SOrderVpsPage {
    init() {
        this.view = new Vue({
            el: "#purchase-vps",
            name: "order-vps-page",
            data() {
                return {
                    brand: null,
                    catalogue: UserCatalogue.inst,
                    dcLocations: [
                        {
                            text: "UK",
                            id: "dc_location-lhr"
                        },
                        {
                            text: "USA",
                            id: "dc_location-dfw"
                        }
                    ],
                    format: Site.Format,
                    installTargetType: "os",
                    platform: VPSPlatform.inst,
                    /** @type {?VPSApplication} */
                    selectedApp: null,
                    /** @type {?boolean} */
                    selectedCPanelObject: null,
                    /** @type {?string} */
                    selectedDiskProduct: null,
                    /** @type {?string} */
                    selectedLocation: "dc_location-lhr",
                    /** @type {?string} */
                    selectedOSGroup: null,
                    /** @type {?{[group: string]: ?string}} Retained */
                    selectedOSVersion: null,
                    /** @type {?number} */
                    selectedPaymentMonths: null,
                    /** @type {?SBVPSProduct} */
                    selectedServerType: null,
                    settings: SharedSettings.inst,
                    type: 'vps',
                    withCpanel: 'no',
                    withDisk: "no",
                    addBackups: false,
                    selectedCpanelCode: "",
                    hasQuery: false,
                    get vpsDisks() {
                        if(!this.catalogue.products) return null
                        //@ts-ignore
                        return this.catalogue.products.filter(
                            p => (p instanceof SBVPSAddonProduct && p.code.match(/vps_addon:disk/) )
                        ).map((p) => {
                            var price = p.pricing.find( p => p.periodMonths == this.selectedPaymentMonths );
                            return {
                                "text": p.label+` (+${this.catalogue.currencySymbol}${price?.price.toFixed(2)})`,
                                "id": p.code
                            };
                        }).sort((a, b) => {
                            const diskA = parseInt(a.id.match(/\d+/)[0]);
                            const diskB = parseInt(b.id.match(/\d+/)[0]);
                            return diskA - diskB;
                        });
                    },
                    get offerCpanel() {
                        return this.cPanelAvailableOptionsSelect.length > 0;
                    },
                    get cPanelAvailableOptionsSelect() {
                        if( this.cPanelProducts ){
                            return this.cPanelProducts.map( (c) => {
                                return {
                                    text: c.label,
                                    id: c.code
                                };
                            } );
                        } else {
                            return [];
                        }
                    },
                    get diskStepNo() {
                        return this.locationStepNo + 1;
                    },
                    get locationStepNo() {
                        if( this.type == 'vps' && this.backupProducts && this.backupProducts.length > 0 ){
                            return +this.backupStepNo + 1;
                        } else {
                            return +this.backupStepNo;
                        }
                    },
                    get backupStepNo() {
                        return this.multiVpsOffered ?
                                   (this.offerCpanel ? 5 : 4)
                               : (this.offerCpanel ? 4 : 3)
                    },
                    /** @type {?SBVPSAddonProduct[]} */
                    get backupProducts() {
                        if(!this.catalogue.products) return null
                        //@ts-ignore
                        return this.catalogue.products.filter(
                            p => (
                                p instanceof SBVPSBackupProduct &&
                                p.typeRef == this.selectedServerType.typeRef
                            )
                        )
                    },
                    /** @type {?SBVPSAddonProduct[]} */
                    get cPanelProducts() {
                        if(!this.catalogue.products) return null
                        //@ts-ignore
                        return this.catalogue.products.filter(
                            p => (
                                p instanceof SBVPSAddonProduct &&
                                p.typeRef.match(/cpanel/)
                            )
                        )
                    },
                    get loading() {
                        return !(
                            this.serverTypes &&
                            this.platform.apps
                        )
                    },
                    get multiVpsOffered() {
                        var bothResult = this.vpsProductByType['vps'] && this.vpsProductByType['managed_vps'];
                        if( !bothResult && !this.hasQuery ){
                            if( this.vpsProductByType['vps'] ){
                                this.type = "vps";
                            } else if ( this.vpsProductByType['managed_vps'] ){
                                this.type = "managed_vps";
                            }
                        }
                        return bothResult;
                    },
                    get notHiddenServerTypes() {
                        if (!this.serverTypes || !this.serverTypes.length) return []

                        return this.serverTypes.filter(t => !t.isHidden)
                    },
                    get offerVpsDisk() {
                        if(!this.catalogue.products) return null
                        return !!this.catalogue.products.find(
                            p => p.code.match(/^vps_addon:disk/)
                        )
                    },
                    get offerVpsLocation() {
                        return true;
                    },
                    get operatingSystemsGrouped() {
                        if(!(
                            this.selectedServerType &&
                            this.selectedServerType.operatingSystems
                        )) return null
                        /** @type {{[name: string]: SBVPSAnyOS[]}} */
                        const grouped = {}
                        for(const os of this.selectedServerType.operatingSystems) {
                            const name = os.groupName
                            if(!grouped[name]) {
                                grouped[name] = []
                            }
                            grouped[name].push(os)
                        }
                        for(const oss of Object.values(grouped)) {
                            oss.sort()
                        }
                        return grouped
                    },
                    get pageQuery() {
                        const query = window.location.search.substr(1).split('&')

                        if (!query) return null

                        /**
                         * @type {{ type: string, code: string }}
                         */
                        const queryObj = query.reduce((result, q) => {
                            const qParts = q.split('=')
                            result[qParts[0]] = qParts[1]
                            return result
                        }, {})

                        return { query, queryObj }
                    },
                    get possibleMonths() {
                        if(!this.catalogue.products) return null
                        /** @type {number[]} */
                        const periods = []
                        for(const p of this.catalogue.products) {
                            if( this.type == 'vps' && ( p instanceof SBVPSProduct || p instanceof SBVPSAddonProduct)  ){
                                for(const pricing of p.pricing) {
                                    if(!periods.includes(pricing.periodMonths)) {
                                        periods.push(+pricing.periodMonths)
                                    }
                                }
                            } else if ( this.type == 'managed_vps' && ( p instanceof SBManagedVPSProduct || p instanceof SBVPSAddonProduct)  ){
                                for(const pricing of p.pricing) {
                                    if(!periods.includes(pricing.periodMonths)) {
                                        periods.push(+pricing.periodMonths)
                                    }
                                }
                            }
                        }
                        return periods.sort((a, b) => a - b)
                    },
                    get selectedCPanel() {
                        return !!this.selectedCPanelObject
                    },
                    get selectedCPanelProduct() {
                        const os = this.selectedOS
                        if(
                            this.selectedCPanel &&
                            os &&
                            this.cPanelProducts
                        ) {
                            return this.cPanelProducts.find(
                                p => (
                                    p.code === this.selectedCPanelObject.code &&
                                    p.provisioningRequirements &&
                                    p.provisioningRequirements.os.includes(
                                        os.typeRef
                                    )
                                )
                            )
                        } else {
                            return null
                        }
                    },
                    /** @type {SBVPSAnyOS | null} */
                    get selectedOS() {
                        const os_version = this.selectedOSVersion
                        const os_group = this.selectedOSGroup
                        if(!os_group) return null
                        if(!os_version) return null
                        if(!this.selectedServerType) return null
                        if(!this.selectedServerType.operatingSystems) return null
                        return this.selectedServerType.operatingSystems.find(
                            os => os.typeRef == os_version[os_group]
                        ) || null
                    },
                    get selectedProducts() {
                        if(!this.selectedServerType) return []
                        /** @type {SBGeneralProduct[]} */
                        const products = [
                            this.selectedServerType
                        ]
                        if(
                            this.selectedOS &&
                            this.selectedOS instanceof SBVPSOSProduct
                        ) {
                            products.push(this.selectedOS)
                        }
                        if(this.selectedCPanelProduct) {
                            products.push(this.selectedCPanelProduct)
                        }
                        if(this.addBackups) {
                            products.push(this.backupProducts[0])
                        }
                        if(this.selectedDiskProduct) {
                            products.push(this.catalogue.products.find(p => p.code == this.selectedDiskProduct))
                        }
                        return products
                    },
                    get serverTypes() {
                        if(!this.catalogue.products) return null

                        let ps = null;

                        if( this.type == 'vps' ) {
                            ps = this.catalogue.products.filter(
                                p => p instanceof SBVPSProduct
                            )
                        } else if ( this.type == 'managed_vps' ) {
                            ps = this.catalogue.products.filter(
                                p => p instanceof SBManagedVPSProduct
                            )
                        }

                        if (!ps) return ps

                        ps.sort(this.priceSort)
                        return ps
                    },
                    get subtotal() {
                        const totals = this.subtotalByType
                        if(totals) {
                            return Object.values(totals).sort(
                                (a, b) => a - b
                            )[0]
                        } else {
                            return null
                        }
                    },
                    get subtotalByType() {
                        const products = this.selectedProducts
                        const months = this.selectedPaymentMonths
                        if(
                            products.length &&
                            this.supportedGeneralPaymentMethods &&
                            months
                        ) {
                            /** @type {{[type: string]: number}} */
                            const totals = {}
                            for(const pm of this.supportedGeneralPaymentMethods) {
                                let total = 0.00
                                let failed = false
                                for(const item of products) {
                                    const p = item.initialPriceForGeneral(
                                        pm,
                                        months
                                    )
                                    if(p === null) {
                                        failed = true
                                        break
                                    } else {
                                        total += p
                                    }
                                }
                                if(!failed) {
                                    totals[pm] = total
                                }
                            }
                            return totals
                        } else {
                            return null
                        }
                    },
                    get supportedGeneralPaymentMethods() {
                        if(this.selectedProducts.length) {
                            let payment_methods =
                                this.selectedProducts[0].pricing.map(
                                    p => p.paymentType
                                )
                            for(const p of this.selectedProducts) {
                                payment_methods = payment_methods.filter(
                                    pm => p.pricing.some(
                                        p => p.paymentType == pm
                                    )
                                )
                            }
                            return payment_methods
                        } else {
                            return []
                        }
                    },
                    get supportedPaymentMonths() {
                        if(this.selectedProducts.length) {
                            let payment_months = this.possibleMonths
                            if(!payment_months) return []
                            for(const p of this.selectedProducts) {
                                payment_months = payment_months.filter(
                                    m => p.pricingSupportsMonths(m)
                                )
                            }
                            return payment_months
                        } else {
                            return []
                        }
                    },
                    get vpsProductByType() {
                        var ps = {
                            "vps": false,
                            "managed_vps": false
                        };
                        if(!this.catalogue.products) return ps
                        for(const p of this.catalogue.products.filter( (i) =>{
                            return (i instanceof SBVPSProduct || i instanceof SBManagedVPSProduct) && !i.isHidden;
                        })){
                            ps[p.codePrefix] = true;
                        }
                        return ps
                    },

                    cpanelAllowed(os){
                        return os == 'Alma' || os == 'Rocky';
                    },
                    async addToBasket() {
                        /** @type {SBasket} */
                        /// @ts-ignore
                        const basket = AnyBasket.inst
                        let basket_item = await this.basketItem();
                        basket_item.serviceConfiguration = {
                            "location": this.selectedLocation
                        };
                        const pic = PaymentItemCollection.inst
                        await basket.addWithInfo(
                            {
                                paymentItemCountries:
                                    await pic.preloadSingle("countriesFlat"),
                            },
                            basket_item
                        )
                        location.href = "/checkout"
                    },
                    /**
                     * @returns {Promise<SBasketItem>}
                     */
                    async basketItem() {
                        if(this.type == 'vps' && !this.selectedOS && !this.selectedApp) {
                            throw new Error("No OS selected")
                        }
                        /** @type {SBVPSProduct} */
                        /// @ts-ignore
                        const server_product = this.selectedProducts[0]
                        const app_ref = this.selectedApp ? this.selectedApp.id : null
                        const os_ref = this.selectedOS ? this.selectedOS.typeRef : null

                        if(!this.subtotalByType) {
                            throw new Error("Cannot get totals")
                        }
                        const totals = Object.entries(this.subtotalByType)

                        const pt = totals.sort(
                            (a, b) => a[1] - b[1]
                        )[0][0]
                        const pm = this.selectedPaymentMonths
                        if(!pm) throw new Error("No months")
                        await UserCatalogue.inst.preload(["config", "userVATRate"])
                        /** @type {SBasketItem} */
                        const basket_item = await server_product.basketItem(
                            server_product.pricingForGeneral(pt, pm)
                        )
                        basket_item.name =
                            "vps-" + Math.floor(Math.random() * 100000)
                        basket_item.productOptionSelections = {
                            app: app_ref,
                            os: os_ref,
                        }
                        let i = 0
                        for(const p of this.selectedProducts.slice(1)) {
                            const sub_basket_item =
                                await p.basketItem(
                                    p.pricingForGeneral(pt, pm)
                                )
                            basket_item.dependentItems[i++] = sub_basket_item
                        }
                        return basket_item
                    },
                    /**
                     *
                     * @param {number} m
                     * @returns {{[class_name: string]: boolean}}
                     */
                    classForPaymentMonths(m) {
                        return {
                            active: this.selectedPaymentMonths == m,
                            disabled: !this.supportedPaymentMonths.includes(m),
                        }
                    },
                    /**
                     *
                     * @param {number} m
                     * @returns {?string}
                     */
                    iconForPaymentMonths(m) {
                        switch(m) {
                            case 1:
                                return "/assets/images/icons/vps/vps-monthly.svg"
                            case 3:
                                return "/assets/images/icons/vps/vps-quarterly.svg"
                            case 6:
                                return "/assets/images/icons/vps/vps-semiannually.svg"
                            case 12:
                                return "/assets/images/icons/vps/vps-yearly.svg"
                            case 24:
                                return "/assets/images/icons/vps/vps-biennally.svg"
                            case 36:
                                return "/assets/images/icons/vps/vps-triennially.svg"
                            default:
                                return null
                        }
                    },
                    /**
                     * @param {(o: SBVPSAnyOS) => boolean} v
                     */
                    ensureOSMatches(f) {
                        if(!(
                            this.selectedOS && f(this.selectedOS)
                        )) {
                            const server_type = this.selectedServerType
                            if(!server_type) {
                                throw new Error("No server")
                            }
                            const os = server_type.operatingSystems
                            if(!os) {
                                throw new Error("No OS options")
                            }
                            const osVersion = this.selectedOSVersion
                            if(!osVersion) {
                                throw new Error("No OS versions")
                            }
                            this.selectedOSGroup = null
                            const operating_systems = os.slice(0)
                            operating_systems.sort(this.priceSort)
                            for(const o of operating_systems) {
                                if(f(o)) {
                                    this.selectedOSGroup = o.groupName
                                    osVersion[o.groupName] = o.typeRef
                                    break
                                }
                            }
                        }
                    },
                    /**
                     *
                     * @param {string} type
                     * @param {SBVPSAddonProduct | VPSApplication | SBVPSAnyOS} item
                     */
                    imageURLFor(type, item) {
                        if(item instanceof VPSApplication) {
                            return `/assets/images/${type}/${type}-ApplicationId-${item.id}.svg`
                        } else {
                            return `/assets/images/${type}/${type}-os-${item.typeRef.replace(/[^a-z]/g,"")}.svg`
                        }
                    },
                    /**
                     *
                     * @param {number} m
                     * @returns {string}
                     */
                    intervalMonthsLabel(m) {
                        return Catalogue.intervalMonthsLabel(m, true)
                    },
                    /**
                     *
                     * @param {SBVPSAnyOS[]} operating_systems
                     * @returns {{id: string, text: string}[]}
                     */
                    osOptions(operating_systems) {
                        return operating_systems.map(
                            os => ({
                                id: os.typeRef,
                                text: os.label || os.typeRef,
                            })
                        )
                    },
                    /**
                     *
                     * @param {SBGeneralProduct | SBVPSFreeOS} a
                     * @param {SBGeneralProduct | SBVPSFreeOS} b
                     */
                    priceSort(a, b) {
                        if(a.lowestPrice && b.lowestPrice) {
                            return (a.lowestPrice.price || 0) - (b.lowestPrice.price || 0)
                        } else {
                            return 0
                        }
                    },

                    disableCPanel(os) {
                        if(os != 'CentOS') {
                            this.selectedCPanelObject = null
                        }
                    },

                    getCPanelLabel(v) {
                        return v.replace('cPanel ', '')
                    },

                    removeCpanel() {
                        this.selectedCPanelObject = null
                    },

                    /**
                     * @param {string} type
                     */
                    lowestPrice(type,spec) {
                        if(!this.catalogue.products || !this.catalogue.prefs) return {};
                        if( this.catalogue.prefs.advertiseMonthlyEquivalent ){
                            var prices3 = spec.pricing.filter( p => true );
                            prices3.sort( (a,b) => {
                                return (a.price / a.periodMonths) - (b.price / b.periodMonths);
                            } );
                            return prices3[0];
                        } else {
                          return spec.pricing[0];
                        }
                    },

                    /**
                     * Compiles using twig.js a description or default template.
                     *
                     * @param {SBManagedVPSProduct}
                     * @returns {string}
                     */
                    serverDescription(serverType){
                        Site.Format.preferGB = true;
                        const descritionFromCode = this.catalogue.productDescriptionFromCode(serverType.code, translation.getActiveLanguage())
                        let template = descritionFromCode && descritionFromCode.length ? descritionFromCode : null || DefaultTemplateCompiler.getTemplateByType(serverType.codePrefix, translation.getActiveLanguage())
                        let serverSpec = {
                            ram: this.format.GB( serverType.ram ),
                            cores: serverType.cores,
                            disc: this.format.GB( serverType.disc )
                        };
                        return DefaultTemplateCompiler.compile(template,{serverSpec:serverSpec});
                    }

                }
            },

            computed: {
            },

            watch: {
                type(v) {
                    console.log(v)
                },
                installTargetType(v) {
                    this.selectedApp = null
                    this.selectedOSGroup = null
                    this.selectedCPanel = null
                },
                operatingSystemsGrouped(v) {
                    if(v && !this.selectedOSGroup) {
                        this.selectedOSGroup =
                            Object.keys(v).find(
                                k => v[k].some(o => o.typeRef == "rhel6")
                            ) ||
                            "CentOS"
                    }
                },
                /** @param {?VPSApplication} v */
                selectedApp(v) {
                    if(v) {
                        this.selectedCPanel = false
                        this.ensureOSMatches(o => o.supportsApp(v.id))
                    }
                },
                withCpanel(v) {
                    if( v == 'no' ){
                        this.selectedCPanelObject = null;
                    } else if (v=='yes' && this.cPanelProducts.length > 0) {
                       this.selectedCPanelObject = this.cPanelProducts[0];
                       this.selectedCpanelCode   = this.selectedCPanelObject.code;
                       this.selectedOSGroup      = 'Alma';
                       this.selectedOS           = {
                           label: "Alma Linux 8",
                           typeRef: "almalinux8"
                       };
                    }
                },
                withDisk(v) {
                    if(v == 'no'){
                        this.selectedDiskProduct= null;
                    } else if (v == 'yes' && !this.selectedDiskProduct) {
                        this.selectedDiskProduct = this.vpsDisks[0].id;
                    }
                },
                selectedCpanelCode(n,o) {
                   var c = this.cPanelProducts.find( p => p.code == n );
                   if( c ){
                       this.selectedCPanelObject = c;
                   }
                },
                async selectedCPanel(v) {
                    if(v) {
                        const cPanelProducts = this.cPanelProducts
                        if(cPanelProducts) {
                            for(const p of cPanelProducts) {
                                await p.preloadSingle(
                                    "provisioningRequirements"
                                )
                            }
                            this.selectedApp = null
                            this.ensureOSMatches(
                                o => cPanelProducts.some(
                                    p => p.provisioningRequirements.os.includes(
                                        o.typeRef
                                    )
                                )
                            )
                        }
                    }
                },
                selectedCPanelObject(v) {
                  this.selectedCPanel = v ? true : false
                },
                /** @param {SBVPSAnyOS | null} v */
                async selectedOS(v) {
                    if(
                        v &&
                        this.selectedApp &&
                        !v.supportsApp(this.selectedApp.id)
                    ) {
                        this.selectedApp = null
                    }
                    const cPanelProducts = this.cPanelProducts
                    if(cPanelProducts) {
                        for(const p of cPanelProducts) {
                            await p.preloadSingle("provisioningRequirements")
                        }
                        if(
                            this.selectedCPanel &&
                            !(
                                v &&
                                cPanelProducts.some(
                                    p => p.provisioningRequirements.os.includes(
                                        v.typeRef
                                    )
                                )
                            )
                        ) {
                            this.selectedCPanel = false
                        }
                    }
                },
                /** @param {?SBVPSProduct} v */
                selectedServerType(v) {
                    this.selectedApp = null
                    this.selectedOSGroup = null
                    this.selectedCPanel = null
                },
                serverTypes(v) {
                    if (v && this.pageQuery && this.hasQuery) {
                        const productMatch = v.find(type => type.code === this.pageQuery.queryObj.code)
                        this.selectedServerType = productMatch
                    }

                    if(v && !this.selectedServerType) {
                        this.selectedServerType = v[0]
                    }
                },
                /**
                 * @param {number[]} v
                 */
                supportedPaymentMonths(v) {
                    if(!(
                        this.selectedPaymentMonths &&
                        v.includes(this.selectedPaymentMonths)
                    )) {
                        this.selectedPaymentMonths = v[0] || null
                    }
                },
            },

            components: {
                shopNav: ShopNav,
                vueSelect: VueSelect,
            },

            mounted() {
                this.$watch(
                    () => this.operatingSystemsGrouped,
                    /** @param {{[group: string]: SBVPSAnyOS[]}} v */
                    function(v) {
                        if(v) {
                            const existing_selected_os_version =
                            this.selectedOSVersion || {}
                            const selected_os_version = {}
                            for(const [name, oss] of Object.entries(v)) {
                                if(
                                    !existing_selected_os_version.hasOwnProperty(name)
                                ) {
                                    selected_os_version[name] =
                                        oss[0].typeRef
                                }
                            }
                            this.selectedOSVersion = Object.assign(
                                {},
                                existing_selected_os_version,
                                selected_os_version
                            )
                        }
                    }
                )
                this.catalogue.assertExists()

                if (!this.pageQuery) return

                const { queryObj: { code, type } } = this.pageQuery

                if (type && code === "upgrade") {
                    return this.type = "managed_vps"
                }

                if (type && code) {
                    this.hasQuery = true
                    this.type = type
                }
            }
        })
    }
}
